var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeometriShapes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 311,
    viewBox: "0 0 237 311",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_173_205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4082 107.884L161.825 133.136L236.502 201.049",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.017 35.4134L161.825 133.136L87.895 265.152",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5626 147.73L148.433 184.09L167.774 209.666L110.497 185.758L60.5879 144.169L89.5626 147.73Z",
    fill: "url(#paint0_linear_173_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.497 185.758L41.9434 296.83L99.1211 311L167.774 209.666L110.497 185.758Z",
    fill: "url(#paint1_linear_173_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.588 144.169L0 248.69L41.9436 296.83L110.497 185.758L60.588 144.169Z",
    fill: "url(#paint2_linear_173_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.422 10.8332L178.777 0L210.091 6.77386L151.096 25.9997L86.1274 27.0207L110.422 10.8332Z",
    fill: "url(#paint3_linear_173_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.097 25.9997L171.508 154.927L224.081 128.38L210.092 6.77386L151.097 25.9997Z",
    fill: "url(#paint4_linear_173_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1274 27.0207L108.331 145.787L171.508 154.927L151.096 25.9997L86.1274 27.0207Z",
    fill: "url(#paint5_linear_173_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.017 35.4134L71.9141 179.383L236.502 201.049L158.017 35.4134Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.016 35.4134L15.4082 107.884L71.9138 179.383L158.016 35.4134Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9141 179.383L87.895 265.152L236.502 201.049L71.9141 179.383Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4082 107.884L87.8947 265.152L71.9138 179.383L15.4082 107.884Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_173_205",
    x1: 187.439,
    y1: 234.122,
    x2: 118.536,
    y2: 176.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F2020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8B1724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#750F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#64082D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#580330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#510031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500032"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_173_205",
    x1: 67.6314,
    y1: 234.655,
    x2: 140.236,
    y2: 270.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#9F2020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#811326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#66092C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#550230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500032"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_173_205",
    x1: 18.1898,
    y1: 197.636,
    x2: 82.003,
    y2: 241.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FF8277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F16C67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E05153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#D64047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D33B43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_173_205",
    x1: 153.362,
    y1: 41.0416,
    x2: 138.413,
    y2: -27.8646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FF8277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D76467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#A74054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#812445"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#66103A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#550434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500032"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_173_205",
    x1: 150.463,
    y1: 91.0482,
    x2: 229.107,
    y2: 71.2056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#9F2020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#811326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#66092C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#550230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500032"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_173_205",
    x1: 88.8496,
    y1: 95.228,
    x2: 165.958,
    y2: 87.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FF8277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F16C67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E05153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#D64047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D33B43"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_173_205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 237,
    height: 311,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeometriShapes);
export default __webpack_public_path__ + "static/media/geometriShapes.ddd59cf1b0950e829a2335287c886ba8.svg";
export { ForwardRef as ReactComponent };